/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';
import VueGtm from 'vue-gtm';
import router from '@/router';
import {state} from '@/store/modules/settings';


/**
 * GTM service.
 *
 * @see https://www.npmjs.com/package/vue-gtm
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

((): void => {
    // attempt to get token
    const gtmId: string|undefined = process.env.VUE_APP_GTMID;

    if (undefined === gtmId || !gtmId) {
        return;
    }

    const isProduction: boolean = 'production' === process.env.NODE_ENV;

    // configure analytics
    Vue.use(VueGtm, {
        id: gtmId, // Your GTM ID
        enabled: !!state.consent,
        debug: !isProduction,
        vueRouter: router,
        ignoredViews: [], // routes name (case insensitive) (optional)
    });
})();

